function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9E9E9E",
  fillRule: "evenodd",
  d: "M12 3c-1.857 0-3.638.706-4.95 1.962C5.738 6.218 5 7.922 5 9.696 5 15.14 12 21 12 21s7-6.28 7-11.304c0-1.775-.738-3.479-2.05-4.734A7.164 7.164 0 0 0 12 3zm0 9.591c-1.224.001-2.328-.704-2.796-1.785a2.802 2.802 0 0 1 .654-3.155 3.125 3.125 0 0 1 3.297-.628c1.131.447 1.869 1.503 1.869 2.673 0 .768-.319 1.504-.885 2.048A3.098 3.098 0 0 1 12 12.59z"
});

var SvgDeliveryAddress = function SvgDeliveryAddress(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), React.createElement("title", null, title), _ref2);
};

export default SvgDeliveryAddress;